import { useRouter } from 'next/router'
import type { Locales } from '@captaincause/types'

export const useNextLocale = () => {
  const router = useRouter()

  return router.locale as Locales
}
